import axios from "axios";


import { API_BASE_URL } from "../../../config/api";
import {
    ADD_ITEM_TO_CART_REQUEST,
    ADD_ITEM_TO_CART_SUCCESS,
    ADD_ITEM_TO_CART_FAILURE,
  GET_CART_FAILURE,
  GET_CART_REQUEST,
  GET_CART_SUCCESS,
  REMOVE_CART_ITEM_FAILURE,
  REMOVE_CART_ITEM_REQUEST,
  REMOVE_CART_ITEM_SUCCESS,
  UPDATE_CART_ITEM_FAILURE,
  UPDATE_CART_ITEM_REQUEST,
  UPDATE_CART_ITEM_SUCCESS,
  CLEAR_CART,
} from "./ActionType";

// export const addItemToCart = (reqData) => async (dispatch) => {
//     console.log("req data ",reqData)
//   try {
   
//     dispatch({ type: ADD_ITEM_TO_CART_REQUEST });
//     const config = {
//       headers: {
//         Authorization: `Bearer ${reqData.jwt}`,
//         "Content-Type": "application/json",
//       },
//     };
//     const { data } = await axios.put(`${API_BASE_URL}/api/cart/add`, 
//       reqData.data,
//       config,
//     );
// console.log("add item to cart ",data)
//     dispatch({
//       type: ADD_ITEM_TO_CART_SUCCESS,
//       payload: data,
//     });
//   } catch (error) {
//     dispatch({
//       type: ADD_ITEM_TO_CART_FAILURE,
//       payload:
//         error.response && error.response.data.message
//           ? error.response.data.message
//           : error.message,
//     });
//   }
// };

export const addItemToCart = (reqData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_ITEM_TO_CART_REQUEST });

    const config = {
      headers: {
        Authorization: `Bearer ${reqData.jwt}`,
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.put(`${API_BASE_URL}/api/cart/add`, reqData.data, config);

    dispatch({
      type: ADD_ITEM_TO_CART_SUCCESS,
      payload: data,
    });

    return data; // ✅ return result to use in `.then()` on frontend
  } catch (error) {
    dispatch({
      type: ADD_ITEM_TO_CART_FAILURE,
      payload:
        error.response?.data?.message || error.message,
    });
    throw error; // ✅ important so error can be caught in UI
  }
};



export const getCart = (jwt) => async (dispatch) => {
  try {
    dispatch({ type: GET_CART_REQUEST });
    const config = {
        headers: {
          Authorization: `Bearer ${jwt}`,
          "Content-Type":"application/json"
        },
      };
    const { data } = await axios.get(`${API_BASE_URL}/api/cart/`,config);
console.log("cart ",data)
    dispatch({
      type: GET_CART_SUCCESS,
      payload: data,
    });
    return data;
  } catch (error) {
    dispatch({
      type: GET_CART_FAILURE,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    throw error;
  }
};

export const removeCartItem = (reqData) => async (dispatch) => {
  try {
    // Optimistically update UI first
    dispatch({
      type: REMOVE_CART_ITEM_SUCCESS,
      payload: reqData.cartItemId,
    });

    const config = {
      headers: {
        Authorization: `Bearer ${reqData.jwt}`,
        "Content-Type": "application/json",
      },
    };

    // API call happens in background
    await axios.delete(`${API_BASE_URL}/api/cart_items/${reqData.cartItemId}`, config);

    // No need to refresh - optimistic update handles it
  } catch (error) {
    // If API fails, revert by re-fetching cart
    dispatch({
      type: REMOVE_CART_ITEM_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
    // Re-fetch cart to restore correct state
    dispatch(getCart(reqData.jwt));
  }
};


export const updateCartItem = (reqData) => async (dispatch) => {
  try {
    // Optimistically update UI immediately
    dispatch({
      type: UPDATE_CART_ITEM_SUCCESS,
      payload: {
        cartItemId: reqData.cartItemId,
        quantity: reqData.data.quantity,
      },
    });

    const config = {
      headers: {
        Authorization: `Bearer ${reqData.jwt}`,
        "Content-Type": "application/json",
      },
    };

    // API call happens in background
    const { data } = await axios.put(
      `${API_BASE_URL}/api/cart_items/${reqData.cartItemId}`,
      reqData.data,
      config
    );

    // No need to refresh - optimistic update handles it
  } catch (error) {
    dispatch({
      type: UPDATE_CART_ITEM_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
    // Re-fetch cart to restore correct state
    dispatch(getCart(reqData.jwt));
  }
};

export const clearCart = () => (dispatch) => {
  dispatch({ type: CLEAR_CART });
};
